import { useState, useEffect } from 'react';
import LoginPage from './pages/LoginPage';
import { ReceivingPage, QCPage, PartnerPage, AdminPage } from './components/Pages';

const ROLE_DEFAULT_PAGE = {
  warehouse: 'receiving',
  qc: 'qc',
  ekart: 'partner',
  reebok: 'partner',
  piyush: 'partner',
  admin: 'admin',
};

const ADMIN_NAV = [
  { id: 'receiving', icon: '📦', label: 'Receive' },
  { id: 'qc',        icon: '🔍', label: 'QC' },
  { id: 'partner',   icon: '🏭', label: 'Partner' },
  { id: 'admin',     icon: '⚙️',  label: 'Admin' },
];

function NavBar({ user, page, onPage, onLogout }) {
  const isAdmin = user?.role === 'admin';
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      background: 'rgba(10,16,30,0.97)', backdropFilter: 'blur(12px)',
      borderBottom: '1px solid rgba(255,255,255,0.07)',
      display: 'flex', alignItems: 'center', padding: '0 12px', height: 52, gap: 6
    }}>
      <span style={{ fontSize: 18 }}>📦</span>
      <span style={{ color: '#fff', fontWeight: 700, fontSize: 14, marginRight: 6 }}>WH Scan</span>

      {isAdmin && (
        <div style={{ display: 'flex', gap: 2, flex: 1, overflowX: 'auto' }}>
          {ADMIN_NAV.map(n => (
            <button key={n.id} onClick={() => onPage(n.id)} style={{
              padding: '4px 9px', borderRadius: 7, border: 'none', whiteSpace: 'nowrap',
              background: page === n.id ? 'rgba(59,130,246,0.25)' : 'transparent',
              color: page === n.id ? '#60a5fa' : '#475569',
              fontSize: 12, cursor: 'pointer', fontWeight: page === n.id ? 700 : 400
            }}>{n.icon} {n.label}</button>
          ))}
        </div>
      )}

      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 6 }}>
        <span style={{ background: 'rgba(255,255,255,0.07)', borderRadius: 5, padding: '2px 7px', color: '#64748b', fontSize: 11 }}>
          {user?.role}
        </span>
        <button onClick={onLogout} style={{
          background: 'none', border: '1px solid rgba(255,255,255,0.09)',
          color: '#475569', borderRadius: 6, padding: '3px 9px', cursor: 'pointer', fontSize: 12
        }}>Out</button>
      </div>
    </div>
  );
}

export default function App() {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('wh_user')); } catch { return null; }
  });
  const [page, setPage] = useState('');

  useEffect(() => {
    if (user) setPage(ROLE_DEFAULT_PAGE[user.role] || 'receiving');
  }, [user]);

  const handleLogin = (u) => { setUser(u); setPage(ROLE_DEFAULT_PAGE[u.role] || 'receiving'); };
  const handleLogout = () => { localStorage.clear(); setUser(null); setPage(''); };

  if (!user) return <LoginPage onLogin={handleLogin} />;

  const renderPage = () => {
    switch (page) {
      case 'receiving': return <ReceivingPage user={user} />;
      case 'qc':        return <QCPage user={user} />;
      case 'partner':   return <PartnerPage user={user} />;
      case 'admin':     return <AdminPage user={user} />;
      default:          return <ReceivingPage user={user} />;
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0a101e', fontFamily: "'Segoe UI',system-ui,sans-serif" }}>
      <NavBar user={user} page={page} onPage={setPage} onLogout={handleLogout} />
      <div style={{ paddingTop: 52 }}>{renderPage()}</div>
    </div>
  );
}
